<template>
    <div class="limited-spots__nest">
        <div class="limited-spots__title">
            {{ product.percentage }}% {{ $t('sales.discount') }} - {{ $t('sales.limitedAvability') }}
        </div>
        <div class="limited-spots__text">
            <div class="limited-spots__ripple"></div>
            <div v-if="remainingSpots">
                {{ $t('sales.only') }} {{ currentLanguage === 'es' ? $t('sales.left') : '' }}
            </div>
            <span class="limited-spots__number">{{ remainingSpots }}</span>
            {{ spots }}
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapGetters(['product']),
        ...mapState({
            remainingSpots: (state) => state.remainingSpots,
        }),
        currentLanguage() {
            return window.App.language;
        },
        spots() {
            if (['de', 'es'].includes(this.currentLanguage)) {
                return this.remainingSpots === 1 ? this.$t('sales.spot') : this.$t('sales.spots');
            }
            return `${this.remainingSpots === 1 ? this.$t('sales.spot') : this.$t('sales.spots')} ${this.$t('sales.left')}`;
        },
    },
    methods: {
        init() {
            this.countRemainingSpots();
            setInterval(() => {
                this.countRemainingSpots();
            }, 5000);
        },
        countRemainingSpots() {
            const now = new Date().getTime();
            const targetTime = new Date(this.product.timer.value).getTime();
            const differenceInMilliseconds = targetTime - now;
            const remainingHours = differenceInMilliseconds / (1000 * 60 * 60);
            const maxSpots = this.product.order_limit;
            const remainingSpots = Math.ceil(1000 * (remainingHours / 109) ** 2.3 + 1);
            const value = remainingSpots > maxSpots ? maxSpots : remainingSpots > 0 ? remainingSpots : 0;

            this.$store.commit('setRemainingSpots', value);
        },
    },
    mounted() {
        this.init();
    },
};
</script>
